// Represents profile enums
export const SELLER_PRO = [ 'SellerPro', 'SellerProAss' ];

export const SELLER_MANAGEMENT = 'SellerManagement';
